import { Container, Row, Col } from "react-bootstrap";
import EditorFaq from "../components/EditorFaq";
import { NamEditor } from "../components/nes/NamEditor";
import "./TitlePage.scss";

export default function TitlePage() {
    return (
        <div className="title-page">
            <Container>
                <Row>
                    <Col>
                        <h1>Title Screen</h1>
                        <p className="mt-3">
                            This screen will show up when your game first boots. You can customize it however you like. Adding your name
                            is a good start.
                        </p>
                        <div className="mt-3">
                            <NamEditor fieldName="titleScreenData" />
                        </div>
                        <EditorFaq />
                    </Col>
                </Row>
            </Container>
        </div>
    )    
}